import { AuthMethodType } from '@portals/types';

export const AUTH_METHOD = {
  [AuthMethodType.CloudId]: 'Cloud ID',
  [AuthMethodType.MacSN]: 'MAC & Serial Number',
  [AuthMethodType.PubKey]: 'Pub Key',
  [AuthMethodType.x509]: 'X.509 Certificate',
};
